import { render, staticRenderFns } from "./TaskModuleRulesSettings.vue?vue&type=template&id=4f6039e5&scoped=true"
import script from "./TaskModuleRulesSettings.vue?vue&type=script&lang=js"
export * from "./TaskModuleRulesSettings.vue?vue&type=script&lang=js"
import style0 from "./TaskModuleRulesSettings.vue?vue&type=style&index=0&id=4f6039e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6039e5",
  null
  
)

export default component.exports